import { render, staticRenderFns } from "./wiki-table-card.vue?vue&type=template&id=16a2c9ff&"
import script from "./wiki-table-card.vue?vue&type=script&lang=ts&"
export * from "./wiki-table-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports